import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'index',
      showTitle: '登录验证',
    },
  },
  {
    name: 'index',
    path: '/index',
    component: () => import('./view/Index'),
    meta: {
      title: 'index',
      showTitle: '登录验证',
    },
  },
  {
    name: 'home',
    path: '/home',
    component: () => import('./view/home/Index'),
    meta: {
      title: 'home',
      showTitle: '业绩信息',
    },
  },
  {
    name: 'team',
    path: '/team',
    component: () => import('./view/team/Index'),
    meta: {
      title: 'team',
      showTitle: '团队业绩信息',
    },
  },
  {
    name: 'person',
    path: '/person',
    component: () => import('./view/person/Index'),
    meta: {
      title: 'person',
      showTitle: '个人业绩信息',
    },
  },
  {
    name: 'barindex',
    path: '/barindex',
    component: () => import('./view/echarts/BarIndex'),
    meta: {
      title: 'barindex',
      showTitle: '柱形图',
    },
  },
  {
    name: 'leaderindex',
    path: '/leaderindex',
    component: () => import('./view/home/LeaderIndex'),
    meta: {
      title: 'leaderindex',
      showTitle: '业绩信息',
    },
  },
  {
    name: 'teamindex',
    path: '/teamindex',
    component: () => import('./view/home/TeamIndex'),
    meta: {
      title: 'teamindex',
      showTitle: '业绩信息',
    },
  },
  {
    name: 'personindex',
    path: '/personindex',
    component: () => import('./view/home/PersonIndex'),
    meta: {
      title: 'personindex',
      showTitle: '业绩信息',
    },
  },
  {
    name: 'opportunity_winper_index',
    path: '/opportunity_winper_index',
    component: () => import('./view/home/opportunity_winper/index'),
    meta: {
      title: 'opportunity_winper_index',
      showTitle: '商机赢单率（体验版）',
      keepAlive: true,
    },
  },
  {
    name: 'opportunity_winper_add',
    path: '/opportunity_winper_add',
    component: () => import('./view/home/opportunity_winper/add'),
    meta: {
      title: 'opportunity_winper_add',
      showTitle: '商机赢单率（体验版）',
      keepAlive: true,
    },
  },
  {
    path: "/selectCustomer",
    name: "selectCustomer",
    component: () => import("./components/selectCustomer/index.vue"),
  },
  {
    name: 'orgindex',
    path: '/orgindex',
    component: () => import('./view/echarts/OrgIndex'),
    meta: {
      title: 'orgindex',
      showTitle: '组织图',
    },
  },
];

const router = createRouter({
  routes: routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.showTitle;
  if (title) {
    document.title = title;
  }
  next();
});

export { router };
